import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Childrens2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/4.webp`;
const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/5.webp`;
const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/6.webp`;
const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/7.webp`;
const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/8.webp`;
const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/9.webp`;  
const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/10.webp`;
const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/Childern/12.webp`;

    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
}

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                           Children’s Day Celebrations
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                   Date: 14 November 2025

                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ Wherever we are, we must remember that the soil of our land has given us everything — our food, our knowledge and our identity. We must give back with dedication and gratitude. -Dr A.P.J. Abdul Kalam ”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
On 14 November 2025, the campus of National Public School, Yeshwanthpur resonated with exuberance and jubilation as students and teachers united to celebrate Children’s Day, commemorating the 130th birth anniversary of Pandit Jawaharlal Nehru.
<br></br>
The festivities commenced with a special assembly orchestrated by the teachers on the  theme ‘Gen Z’. The assembly encompassed a Thought for the Day, Word of the Day, a lively Lazy Dance, melodious songs, captivating dances, an engaging quiz, a spirited flash mob and an inspiring Teacher’s Address.
<br></br>
The Principal, Ms Sheeja Manoj, extended heartfelt greetings to the children, underscoring the significance of the occasionand motivated the students to ‘Dream big and to keep the child alive in them throughout their life.’ The celebration unfolded with magnificent grandeur and festive brilliance, as the school grounds brimmed with enthusiasm and delight. The day was filled with merriment, camaraderie and boundless laughter, leaving indelible memories for the students.
<br></br>
Children’s Day at NPS Yeshwanthpur was not merely an event but a vibrant tapestry of joy, creativity and youthful exuberance, epitomizing the spirit of the generation it honoured.
                               <br></br>
                                  </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ChildernVE SATHYA ChildernVE NITHYA”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Childrens2025;